import React, { useState } from "react";

export function StatCard({
  title,
  value,
  subtitle,
  valueColor,
  danishDescription,
  englishDescription,
  arabicDescription,
}: {
  title: string;
  value: string;
  subtitle?: string;
  valueColor?: string;
  danishDescription?: string;
  englishDescription?: string;
  arabicDescription?: string;
}) {
  const [showInfo, setShowInfo] = useState(false);

  return (
    <div
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: 12,
        padding: 16,
        background: "#fff",
        boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
        position: "relative",
      }}
    >
      {danishDescription || englishDescription || arabicDescription ? (
        <>
          <button
            type="button"
            onMouseEnter={() => setShowInfo(true)}
            onMouseLeave={() => setShowInfo(false)}
            onFocus={() => setShowInfo(true)}
            onBlur={() => setShowInfo(false)}
            onClick={() => setShowInfo((prev) => !prev)}
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              width: "20px",
              height: "20px",
              borderRadius: "50%",
              border: "1px solid #197770",
              background: "#fff",
              color: "#197770",
              fontSize: "12px",
              fontWeight: 700,
              lineHeight: "18px",
              cursor: "pointer",
            }}
            aria-label="Vis forklaring"
            title="Vis forklaring"
          >
            i
          </button>

          {showInfo ? (
            <div
              style={{
                position: "absolute",
                top: 36,
                right: 10,
                zIndex: 5,
                maxWidth: "300px",
                background: "#f8fafc",
                border: "1px solid #dbe4ee",
                borderRadius: "8px",
                padding: "8px 10px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                fontSize: "13px",
                lineHeight: 1.5,
              }}
            >
              {danishDescription ? (
                <div style={{ color: "#334155", marginBottom: englishDescription || arabicDescription ? "8px" : "0" }}>
                  <div style={{ fontSize: "11px", fontWeight: 700, color: "#0f766e", marginBottom: "2px" }}>
                    Dansk
                  </div>
                  <div>{danishDescription}</div>
                </div>
              ) : null}
              {englishDescription ? (
                <div style={{ color: "#334155", marginBottom: arabicDescription ? "8px" : "0" }}>
                  <div style={{ fontSize: "11px", fontWeight: 700, color: "#0f766e", marginBottom: "2px" }}>
                    English
                  </div>
                  <div>{englishDescription}</div>
                </div>
              ) : null}
              {arabicDescription ? (
                <div style={{ color: "#334155", direction: "rtl", textAlign: "right" }}>
                  <div style={{ fontSize: "11px", fontWeight: 700, color: "#0f766e", marginBottom: "2px" }}>
                    العربية
                  </div>
                  <div>{arabicDescription}</div>
                </div>
              ) : null}
            </div>
          ) : null}
        </>
      ) : null}

      <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 6 }}>
        {title}
      </div>
      <div
        style={{
          fontSize: 20,
          fontWeight: 700,
          color: valueColor || "#111827",
          lineHeight: 1.3,
        }}
      >
        {value}
      </div>
      {subtitle ? (
        <div style={{ fontSize: 12, color: "#6b7280", marginTop: 6 }}>
          {subtitle}
        </div>
      ) : null}
    </div>
  );
}

